import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressComponent } from './address.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {GeneralDropdownModule} from "../general-dropdown/general-dropdown.module";



@NgModule({
  declarations: [
    AddressComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        GeneralDropdownModule
    ],
  exports:[
    AddressComponent
  ]
})
export class AddressModule { }
